export enum ChipSize {
  Xxs = 'chip-xxs',
  Xs = 'chip-xs',
  Sm = 'chip-sm',
  Md = ''
}
